import omit_deep from "omit-deep";
import rename_deep from "deep-rename-keys";
import { parseSync } from "xml-reader";

const parseInput = input => parseSync(input, { parentNodes: false });
const removeDoctype = input => {
    return input.replace(/<[/]{0,1}(!?DOCTYPE|\??xml)[^><]*>/gi, "");
};
const wrapInput = input => `<root>${input}</root>`;
const removeAttrs = obj => omit_deep(obj, ["parent"]);

/*
const addCustomAttrs = (attrs, node) => ({
    ...node,
    ...attrs,
});
*/

const camelize = node => {
    return rename_deep(node, key => {
        if (!notCamelcase(key)) {
            return toCamelCase(key);
        }
        return key;
    });
};

const toCamelCase = prop =>
    prop.replace(/[-|:]([a-z])/gi, (all, letter) => letter.toUpperCase());

const fromCamelCase = prop => prop
    .replace(/([a-z\d])([A-Z])/gu, "$1-$2")
    .replace(/([A-Z]+)([A-Z][a-z]+)/gu, "$1-$2")
    .toLowerCase();

const notCamelcase = prop => /^(aria)(-\w+)/.test(prop);

const escapeText = text => {
    if (text) {
        const str = String(text);
        return /[&<>]/.test(str)
            ? `<![CDATA[${str.replace(/]]>/, "]]]]><![CDATA[>")}]]>`
            : str;
    }
    return "";
};

const escapeAttr = attr => {
    return String(attr)
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&apos;")
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
};

const parse = function (input, { transformNode = node => node, camelcase = true } = {}) {
    const wrap = input => {
        const cleanInput = removeDoctype(input);
        return wrapInput(cleanInput);
    };

    const unwrap = res => {
        return res.name === "root" ? res.children : res;
    };

    camelcase = true;

    const applyFilters = input => {
        const applyTransformNode = node => {
            const children = node.children;
            return node.name === "root"
                ? children.map(applyTransformNode)
                : {
                    ...transformNode(node),
                    ...(children && children.length > 0
                        ? {
                            children: children.map(applyTransformNode),
                        }
                        : {}),
                };
        };
        let n;
        n = removeAttrs(input);
        n = applyTransformNode(n);
        if (camelcase) {
            n = camelize(n);
        }
        return n;
    };

    return unwrap(applyFilters(parseInput(wrap(input))));
};

const parse_async = function svgson(...args) {
    return new Promise((resolve, reject) => {
        try {
            const res = serialize(...args);
            resolve(res);
        } catch (e) {
            reject(e);
        }
    });
};

const stringify = (
    ast,
    {
        transformAttr = (key, value, escape) => `${fromCamelCase(key)}="${escape(value)}"`,
        selfClose = true,
    } = {}
) => {
    if (Array.isArray(ast)) {
        return ast.map(ast => stringify(ast, { transformAttr, selfClose })).join("");
    }

    if (ast.type === "text") {
        return escapeText(ast.value);
    }

    let attributes = "";
    for (const attr in ast.attributes) {
        const attrStr = transformAttr(
            attr,
            ast.attributes[attr],
            escapeAttr,
            ast.name
        );
        attributes += attrStr ? ` ${attrStr}` : "";
    }

    return ast.children.length || !selfClose
        ? `<${ast.name}${attributes}>${stringify(ast.children, {
            transformAttr,
            selfClose,
        })}</${ast.name}>`
        : `<${ast.name}${attributes}/>`;
};


export default {parse_async, parse, stringify};
